import React from "react";
import { FileItemProps } from "./FileItem.props";
import { P } from "common/P/P";
import { ReactComponent as PdfIcon } from "common/assets/icons/Pdf.svg";
import { ReactComponent as DocxIcon } from "common/assets/icons/Docx.svg";
import { ReactComponent as XlsxIcon } from "common/assets/icons/Xls.svg";
import { ReactComponent as TrashIcon } from "common/assets/icons/trash.svg";
import { ReactComponent as DownloadIcon } from "common/assets/icons/download.svg";
import { ReactComponent as EyeIcon } from "common/assets/icons/eye.svg";

const FileItem: React.FC<FileItemProps> = ({
	name,
	size,
	type,
	notDeletable = false,
	canView = false,
	onDelete,
	onView,
	onDownload,
}) => {
	return (
		<div className="p-4 rounded-md cursor-pointer bg-[#F7F7F7] grid grid-cols-1 gap-2 w-full min-w-[153px]">
			<div className="grid grid-cols-1 gap-2 place-items-center">
				{type === "pdf" ? (
					<PdfIcon />
				) : type === "xlsx" ? (
					<XlsxIcon />
				) : type === "docx" ? (
					<DocxIcon />
				) : null}

				<div className="grid grid-cols-1 place-items-center">
					<P size="p3" type="regular" className="cursor-pointer">
						{name}
					</P>
					<P
						size="t2"
						type="regular"
						className="cursor-pointer place-self-center text-grayTwo"
					>
						{size}mb
					</P>
				</div>
			</div>
			{notDeletable ? (
				<div className="grid grid-cols-1">
					<div
						className="rounded-[4px] bg-lowOpacity py-2 px-4 w-full grid grid-cols-1 place-content-center place-items-center"
						onClick={onDownload}
					>
						<DownloadIcon />
					</div>
				</div>
			) : canView ? (
				<div className="grid grid-cols-2 gap-1 place-items-center">
					<div
						className="rounded-[4px] bg-redBgColor py-2 px-4 w-full grid grid-cols-1 place-content-center place-items-center"
						onClick={onView}
					>
						<EyeIcon className="w-4 h-4" />
					</div>
					<div
						className="rounded-[4px] bg-lowOpacity py-2 px-4 w-full grid grid-cols-1 place-content-center place-items-center"
						onClick={onDownload}
					>
						<DownloadIcon />
					</div>
				</div>
			) : (
				<div className="grid grid-cols-2 gap-1 place-items-center">
					<div
						className="rounded-[4px] bg-redBgColor py-2 px-4 w-full grid grid-cols-1 place-content-center place-items-center"
						onClick={onDelete}
					>
						<TrashIcon />
					</div>
					<div
						className="rounded-[4px] bg-lowOpacity py-2 px-4 w-full grid grid-cols-1 place-content-center place-items-center"
						onClick={onDownload}
					>
						<DownloadIcon />
					</div>
				</div>
			)}
		</div>
	);
};

export default FileItem;
